// import './TransportSummary.css'
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  addOrder,
  modifyLocalForm,
  resetOrder,
} from "../../redux/actions-exporter";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Map from "./Map";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import SideGallery from "../repeats/sideGallery/SideGallery";
import PaymentSuccess from "../repeats/paymentSuccess/PaymentSuccess";

import bannerImg from "../../assets/images/TII/0d29cde6ea92435fc56819d5d1f3d55a.jpg";
// import mainImg from "../../assets/images/storing.jpg";
import galleryImg1 from "../../assets/images/PS/912_0126.jpg";
import galleryImg2 from "../../assets/images/PS/Boost_18_1101_149.jpg";
import galleryImg3 from "../../assets/images/PS/Stokado_Self_Storage1lr-768x512-jpg.jpg";
import galleryImg4 from "../../assets/images/PS/businessStorage.jpg";
import galleryImg5 from "../../assets/images/PS/maxresdefault.jpg";
import galleryImg6 from "../../assets/images/PS/privateStorage.jpg";
import storage from "./Storage";

const StorageSummery = ({ mainLogo, isMoving }) => {
  const [start, setStart] = useState(true);
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const form = useSelector((state) => state.form);
  // useEffect(() => {
  //   if (start) document.querySelector(".homeTitle").scrollIntoView();
  //   setStart(false);
  // }, []);

  const { order } = useSelector((state) => state.order.order);

  // const [isMoving, setIsMoving] = useState();
  const [totalPrice, setTotalPrice] = useState(2000);
  const [checked, setChecked] = useState(false);
  const [isMonths, setIsMonths] = useState(false);
  const [only, setOnly] = useState(false);
  const [months, setMonths] = useState(1);
  const [showS, setShowS] = useState(false);
  const [readS, setReadS] = useState(false);
  const [showM, setShowM] = useState(false);
  const [readM, setReadM] = useState(false);
  const [validated, setValidated] = useState(false);
  const [movingPrice, setMovingPrice] = useState(0);
  const [isAddMoving, setIsAddMoving] = useState(false);
  const [send, setSend] = useState(false);
  const [isItems, setIsItems] = useState(form.isItems);

  const handleIsAddMoving = () => {
    setOnly(true);
    setIsAddMoving(true);
  };
  const handleCloseOnly = () => {
    // document.querySelector(".web-sideBar").firstChild.firstChild.scrollBy(0, 100)
    setOnly(false);
    // navigate("/storagepay");
  };
  const addedOrder = useSelector((state) => state.order.addedOrder);

  const items = ["מקרר", "מכונת כביסה", "ארון בגדים", "מקרר"];

  const galleryArr = [
    {
      img: galleryImg1,
    },
    {
      img: galleryImg2,
    },
    {
      img: galleryImg3,
    },
    {
      img: galleryImg4,
    },
    {
      img: galleryImg5,
    },
    {
      img: galleryImg6,
    },
  ];

  useEffect(() => {
    if (form.storageDateTo && form.storageDateFrom) {
      const date1 = new Date(form.storageDateFrom.replace(/-/g, "/"));
      const date2 = new Date(form?.storageDateTo.replace(/-/g, "/"));
      if (date2) {
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        const months = Math.ceil(
          (diffDays +
            (date2.getMonth() - date1.getMonth()) +
            12 * (date2.getFullYear() - date1.getFullYear())) /
          30
        );
        setMonths(months);
      } else {
        setMonths(1);
      }
    }
    if (form.isItems === true) {
      setMovingPrice(
        form.cart.reduce(
          (total, item) => total + item.price * (item.number || 1),
          0
        )
      );
    }
    if (form.isItems === false) {
      setMovingPrice(250 * form.volume);
    }
  }, []);

  useEffect(() => {
    dispatch(
      modifyLocalForm({
        ...form,
        storage: { ...form.storage, quantity: months },
      })
    );
  }, [months]);

  useEffect(() => {
    if (addedOrder) {
      setSend(true);
      dispatch(resetOrder());
      setStart(true)
    }
  }, [addedOrder]);

  const monthsDisplay = (event) => {
    setIsMonths(event.target.checked);

    dispatch(
      modifyLocalForm({
        ...form,
        isMonths: event.target.checked,
        storage: { ...form.storage, quantity: months },
      })
    );
  };

  useEffect(() => {
    if (!isMonths) {
      setMonths(1)
    }
  }, [isMonths])

  const handleSubmit = (e) => {
    e.preventDefault();
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation();
    } else {
      let cart = [];
      let movingPrice = 0;
      if (isAddMoving && isItems) {
        cart =
          form.cart.map((item) => ({
            id: item.entityId,
            quantity: item.number || 1,
            price: item.price,
          })) || [];
        movingPrice = form.cart.reduce(
          (total, item) => total + item.price * (item.number || 1),
          0
        );
      }
      if (isAddMoving && !isItems) {
        cart = [
          {
            id: 277606,
            quantity: parseInt(form.volume) || 1,
            price: 250,
          },
        ];
        movingPrice = form.cart.reduce(
          (total, item) => total + item.price * (item.number || 1),
          0
        );
      }
      const date = {
        status: "new",
        StoreMerchantId: process.env.REACT_APP_STORAGE_MERCHANT_ID,
        phone: form?.phone || "",
        email: form?.email || "",
        address: form?.address || "",
        productTotal:
          (form?.storage?.price * form?.storage?.quantity || 0) + movingPrice,
        price: form?.storage?.price * form?.storage?.quantity + movingPrice,
        products:
          [
            {
              id: form?.storage?.entityId,
              price: form?.storage?.price,
              quantity: form?.storage?.quantity,
            },
            ...cart,
          ] || [],
        extraFields: form?.extraFields
          ? { ...form.extraFields, ordertype: "booking", volume: form?.volume }
          : { ordertype: "booking", volume: form?.volume },
      };
      dispatch(addOrder(date, "only_storage"));
      // if (isAddMoving) {
      //   setOnly(true);
      // }
      
      // else {
      //   navigate("/storagepay");
      // }
    }
    setValidated(true);
  };
  return (
    <div className="transportFewItems">
      {/* <div className="page_banner">
        <img src={bannerImg} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הזמנת אחסנה אונליין</h1>
            <p>רק למלא פרטים ולשלוח</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/onlinestorage" />
            <MainBtn
              text="הזמנה בעזרת נציג"
              link="/getbackStorage"
              isLight={true}
            />
          </div>
        </div>
      </div>

      <Pros /> */}

      <div className="servicesDiv">
        <h1 className="homeTitle">פרטי הזמנה</h1>
        <div className="splitDiv">
          {/* <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
            >
              <Map />
            </SideGallery>
          </div> */}

          <div className="formSide">
            {send ? (
              <PaymentSuccess
                text1="תודה שבחרתם בנו!"
                text2="העתק הצעת המחיר על תנאי תשלח אליכם למייל"
                text3="נציגנו יצרו עמכם קשר בהקדם להשלמת התהליך"
              />
            ) : (
              <Form
                className="formBox"
                onSubmit={handleSubmit}
                noValidate
                validated={validated}
              >
                <div className="order-summary-header" style={{ marginTop: 0 }}>
                  אחסנה
                </div>

                <div className="order-summary-container">
                  <p>{form?.storage?.title}</p>
                  <p>תאריך תחילת אחסנה: {(format(new Date(form?.storageDateFrom), "dd-MM-yyyy"))}</p>
                  {form?.storageDateTo ? (
                    <p>תאריך סיום אחסנה: {(format(new Date(form?.storageDateTo), "dd-MM-yyyy"))}</p>
                  ) : null}
                  <p>
                    <strong className="moving-total-price">
                      חודשי אחסנה: {months}
                    </strong>
                  </p>

                  <p>
                    <strong className="moving-total-price">
                      מחיר אחסנה לחודש כולל מע''מ: {form?.price} ₪
                    </strong>
                  </p>
                  <p>
                    {form.extraFields?.isAddmoving ? (
                      <strong className="moving-total-price">
                        מחיר הובלה כולל מע''מ: {movingPrice} ₪
                      </strong>
                    ) : null}
                  </p>
                  <p className="storge-time-div">
                    <input
                      onChange={monthsDisplay}
                      type="checkbox"
                      id="addPackage"
                    />
                    <label className="add-package" htmlFor="addPackage">
                      האם לשריין תקופת אחסנה?
                    </label>
                  </p>
                  {isMonths ? (
                    <Row className="mb-3 row">
                      <Form.Group as={Col} controlId="formBasicName">
                        <Form.Label className="fw-semibold mb-2">
                          מספר חודשים לשריון מקום
                        </Form.Label>
                        <Form.Select
                          // aria-label="Default select example"
                          value={months}
                          onChange={(e) => setMonths(e.target.value)}
                        >
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                          <option value="13">13</option>
                          <option value="14">14</option>
                          <option value="15">15</option>
                          <option value="16">16</option>
                          <option value="17">17</option>
                          <option value="18">18</option>
                          <option value="19">19</option>
                          <option value="20">20</option>
                        </Form.Select>
                      </Form.Group>
                    </Row>
                  ) : (
                    ""
                  )}

                  <p>
                    אי שריון פירושו אחסנה לחודש ימים עם אופציה להארכה על בסיס מקום
                    פנוי בלבד, כאמור בתקנון האחסנה
                  </p>
                  <div className="contact-btnDiv send">
                    <MainBtn
                      text="הוספת/הסרת פריטים"
                      link="/onlinestorage"
                    />
                  </div>
                </div>

                <div className="filter-btn-div">
                  <Form.Group className="mb-3">
                    <Form.Check
                      onChange={() => setReadS(prev => !prev)}
                      checked={readS}
                      inline
                      reverse
                      required
                      feedback="נא לאשר את התקנון"
                      feedbackType="invalid"
                      label={
                        <>
                          {"  קראתי ואני מאשר את "}
                          <span onClick={() => setShowS(true)} className="terms">
                            תקנון האחסנה
                          </span>
                        </>
                      }
                    />
                    {form.extraFields.isAddmoving && (
                      <Form.Check
                        onChange={() => setReadM(prev => !prev)}
                        checked={readM}
                        inline
                        reverse
                        // required
                        feedback="נא לאשר את התקנון"
                        feedbackType="invalid"
                        label={
                          <>
                            {"  קראתי ואני מאשר את "}
                            <span onClick={() => setShowM(true)} className="terms">
                              תקנון ההובלה
                            </span>
                          </>
                        }
                      />
                    )}
                  </Form.Group>
                </div>


                {/* LEGACY */}
                {/* {isMoving ? (
                  <>
                    <div className="order-summary-header">הובלה</div>

                    <div className="order-summary-container">
                      <div className="order-personaldetails">
                        <p>
                          <strong>שם מלא:</strong> ישראלה ישראלי
                        </p>
                        <p>שעת תחילה הובלה: 09:00-12:00</p>
                        <p>תאריך מעבר: 24/09/22</p>
                      </div>
                      <div className="present-address">
                        <h5 className="address-title">
                          <strong> כתובת נוכחית:</strong> נתניה
                        </h5>
                        <p> קומה: 2 </p>
                        <p> מעלית: 4 נוסעים</p>
                        <p> שביל כניסה חריג: אין</p>
                        <p> מנוף: לא</p>
                      </div>
                      <div className="chosen-items-list">
                        <strong>פריטים שבחרתי:</strong>
                        <ul>
                          {items.map((item, idx) => {
                            const itemQuantity = items.filter(
                              (item2) => item2 === item
                            ).length;
                            return (
                              <li key={idx} className="li-item">
                                {itemQuantity > 0
                                  ? `${item}`
                                  : `${item} X ${itemQuantity}`}
                              </li>
                            );
                          })}
                        </ul>{" "}
                      </div>

                      <div className="contact-btnDiv send">
                        <MainBtn text="הוספת/הסרת פריטים" link="/onlinestorage" />
                      </div>

                      <strong className="moving-total-price">
                        מחיר הובלה כולל מע''מ: {totalPrice} ₪
                      </strong>
                    </div>

                    <div className="terms-container">
                      <div className="filter-btn-div ">
                        <Form.Group className="mb-3">
                          <Form.Check
                            disabled={!readM}
                            inline
                            reverse
                            required
                            feedback="נא לאשר את התקנון"
                            feedbackType="invalid"
                            label={
                              <>
                                {"  קראתי ואני מאשר את "}
                                <span
                                  onClick={() => setShowM(true)}
                                  className="terms"
                                >
                                  תקנון ההובלה
                                </span>
                              </>
                            }
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )} */}

                <div className="filter-btn-div send">
                  <Button className="filter-btn storagePay light" type="submit">
                    <div className="rightPay">
                      <h1> הזמנת </h1>
                      <h3>
                        {form.extraFields.isAddmoving ? "אחסנה בלבד" : "אחסנה"}
                      </h3>
                    </div>
                    <div className="leftPay">
                      <p>חודש 1{isMonths ? ` (מתוך ${months})` : ""}:</p>
                      <h5>{form?.price} ₪</h5>
                      <p>(כולל מע"מ)</p>
                    </div>
                  </Button>
                </div>
                {form.extraFields.isAddmoving ? (
                  <div className="filter-btn-div send">
                    <Button className="filter-btn storagePay" type="submit"> 
                      <div className="rightPay" onClick={handleIsAddMoving}>
                        <h1> הזמנת </h1>
                        <h3>אחסנה והובלה </h3>
                      </div>
                      <div className="leftPay" onClick={handleIsAddMoving}>
                        <p>חודש 1{isMonths ? ` (מתוך ${months})` : ""}:</p>
                        <h5>אחסנה חודשית {form.price} ₪ </h5>
                        <h5>הובלה חד פעמית {movingPrice} ₪ </h5>
                        <p>(כולל מע"מ)</p>
                      </div>
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </Form>
            )}
          </div>
        </div>
      </div>
{/* 
      <Reviews />
      <Footer /> */}
      <Modal show={showS} onHide={() => setShowS(false)}>
        <Modal.Header closeButton className="ml-0" style={{ width: "100%" }}>
          <Modal.Title>תקנון אחסנה</Modal.Title>
        </Modal.Header>
        <Modal.Body>פירוט פירוט...</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowS(false);
              setReadS(true);
            }}
          >
            קראתי
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showM} onHide={() => setShowM(false)}>
        <Modal.Header closeButton className="ml-0" style={{ width: "100%" }}>
          <Modal.Title>תקנון הובלה</Modal.Title>
        </Modal.Header>
        <Modal.Body>פירוט פירוט...</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowM(false);
              setReadM(true);
            }}
          >
            קראתי
          </Button>
        </Modal.Footer>
      </Modal>

      {/* {only && (
        <Modal show={only} onHide={handleCloseOnly} className="only">
          <Modal.Header closeButton>
            <Modal.Title className="modal-title">{"לתשומת ליבך:"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>התשלום המקוון בעמוד הבא הוא לאחסנה בלבד!</h6>
            <p>
              אישור הזמנת ההובלה יישלח למייל שלך ונציגנו ייצור עמך קשר בהקדם
              לתיאום והסדרת תשלום ההובלה
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleCloseOnly}
              variant="warning"
            // className="filter-btn storagePay "
            >
              הבנתי
            </Button>
          </Modal.Footer>
        </Modal>
      )} */}
    </div>
  );
};

export default StorageSummery;
